module.exports = __webpack_public_path__ + "img/bune_header.b0cab0a6.jpg";